module.exports = __webpack_public_path__ + "static/img/picture1.2eca220d.png";